module.exports = __webpack_public_path__ + "static/media/8.92467e16.jpg";